<script setup lang="ts">
const route = useRoute();
const siteUrl = 'https://www.qiksolve.com';

useSeoMeta({
  ogType: 'website',
  ogSiteName: 'QikSolve',
  ogTitle: 'QikSolve — Practical Quality Systems on Microsoft 365',
  ogDescription: 'QikSolve supports regulated teams with practical quality systems and Microsoft 365 governance.',
  ogUrl: () => {
    const canonicalPath = route.path === '/' ? '/' : `${route.path.replace(/\/$/, '')}/`;
    return `${siteUrl}${canonicalPath}`;
  },
  ogImage: `${siteUrl}/images/qiksolve_cropped-logo.png`,
  twitterCard: 'summary_large_image',
  twitterTitle: 'QikSolve — Practical Quality Systems on Microsoft 365',
  twitterDescription: 'QikSolve supports regulated teams with practical quality systems and Microsoft 365 governance.',
  twitterImage: `${siteUrl}/images/qiksolve_cropped-logo.png`,
});

useHead(() => {
  const canonicalPath = route.path === '/' ? '/' : `${route.path.replace(/\/$/, '')}/`;

  return {
    link: [{ rel: 'canonical', href: `${siteUrl}${canonicalPath}` }],
    script: [
      {
        type: 'application/ld+json',
        innerHTML: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'QikSolve Pty Ltd',
          url: siteUrl,
          logo: `${siteUrl}/images/qiksolve_cropped-logo.png`,
        }),
      },
    ],
  };
});
</script>

<template>
  <NuxtRouteAnnouncer />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <ConsentBanner />
</template>
